import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-how-to-reach', templateUrl: './how-to-reach.component.html', styleUrls: ['./how-to-reach.component.scss'] })
export class HowToReachComponent implements OnInit { constructor() { } ngOnInit(): void { } }
